// extracted by mini-css-extract-plugin
var _1 = "OneColumnPage-module__animateUploadProgressBarWidth--aYP2R";
var _2 = "OneColumnPage-module__animatedBackground--XfGaj";
var _3 = "OneColumnPage-module__container--h_zCz";
var _4 = "OneColumnPage-module__content--isXOt";
var _5 = "OneColumnPage-module__hasBanner--_dHrp";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "content", _5 as "hasBanner" }
